angular.module('BGEHeroes.directives.Lepes3', [])

.directive('lepes3', ['loaderSvcLepes3', '$location', 'Gateway', '$rootScope', function (loaderSvcLepes3, $location, Gateway, $rootScope) {
       "use strict";
       return {
           restrict : 'EAC',
           replace : true,
           scope :{
			    onProxyMessage: '&'
           },
           template: "<canvas></canvas>",
           link: function (scope, element, attribute) {
			   
               var w, h, lepes;
			   
			   var hatter1, hatter2, bar, logo, tovabb, ujra, kihagy;
			   
			   var STAGE_WIDTH, STAGE_HEIGHT, STAGE_ASPECT_RATIO, scope;
			   
			   var visszaallitas;
			   var kattintva;
			   
			   var ablak_nagy, ablakszoveg, tippszoveg;
							
			   var palyaszam, pontszam;
			   
			   var indulopontszam;
			   var eletekszama;

			   var myrate = Gateway.framerate;
			   
			   var hozzavalok = [];
			   var szinkockak = [];
			   
			   var tipp;

			   var kihagypos = [1920-250, 1080-140];
			   var tipppos = [1920-250-250-280, 1080-140];
			   var ujrapos = [1920-250-240, 1080-140];
			   var tovabbpos = [1920-250, 1080-140];
			   
			   
			   var uzenet;		   
			   var lock;
			   var megoldva;
			   
			   var vege=0;

				var balfelso = [300,140];
			   
			   var szomszedok = [
					[],
					[2,3,4,5,6,7,8], //1
					[1,3,8,9,11], //2
					[1,2,4,9],//3
					[1,3,5,9,10],//4
					[1,4,6,10],//5
					[1,5,7,10],//6
					[1,6,8,10,11],//7
					[1,2,7,11],//8
					[2,3,4,10,11],//9
					[4,5,6,7,9,11],//10
					[2,7,8,9,10],//
				];

			   var szinek = ["orange", "red", "yellow", "green"];		   
			   var szinekrgb = [[255, 128, 0], [255, 0, 0], [255, 255, 0], [0, 255, 0]];		   
			   var szinezesek = ["","","","","","","","","","","",""];
			   var szinpointer = 0;
			   
			   var szovegek = {
					tipp: "A matematika egyik nevezetes tétele a négyszín-tétel, amely azt mondja ki, hogy bárhogyan is osztjuk tartományokra a síkot, mindig ki lehet színezni legfeljebb négy szín felhasználásával úgy, hogy semelyik két szomszédos tartomány ne legyen azonos színű. Ezt a szabályt betartva színezd ki az alábbi ábrát! 4 színből mindig egy van kijelölve és amelyik tartományt megérinted azt kitölti az adott színnel. ",
					start: "Oldd meg a feladványt, hogy semelyik két szomszédos tartomány ne legyen azonos színű",
					kesz: "Gratulálunk, a feladat megoldása sikeres volt!",
					nem: "Sajnos a feladat megoldása sikertelen volt!"
			   };
			   
			   
			   lepes=0;
									
               drawGame();
			   
               function drawGame() {
                   if (scope.stage) {
                       scope.stage.autoClear = true;
                       scope.stage.removeAllChildren();
                       scope.stage.update();
                   } else {
                       scope.stage = new createjs.Stage(element[0]);
                   }
                   w = scope.stage.canvas.width = STAGE_WIDTH = 1920;
                   h = scope.stage.canvas.height = STAGE_HEIGHT = 1080;
				   
					loaderSvcLepes3.getLoader().addEventListener("complete", handleComplete);
					loaderSvcLepes3.loadAssets();

					/////////////////////////////////////////
					STAGE_ASPECT_RATIO = STAGE_WIDTH / STAGE_HEIGHT;
					var containerWidth = window.innerWidth;
					var containerHeight = window.innerHeight;
					var brratio = containerWidth/containerHeight;
					if (STAGE_ASPECT_RATIO>brratio){
						//A Stage magasabb. Teljes szélesség, a magasságot kell korlátozni.
						scope.stage.canvas.width = containerWidth;
						scope.stage.canvas.height = containerWidth / ref;
						   
					}else{
						//A Stage szélesebb. Teljes magasság, a szélességet kell korlátozni.
						scope.stage.canvas.width = containerHeight * ref;
						scope.stage.canvas.height = containerHeight;
					}
					// scale stage to fit canvas
					var scalex = scope.stage.canvas.width / STAGE_WIDTH;
					var scaley = scope.stage.canvas.height / STAGE_HEIGHT;
					scope.stage.scaleX = scalex;
					scope.stage.scaleY = scaley;
					scope.stage.update();					
					/////////////////////////////////////////////
				   
               }


               function handleComplete() {
				   	
					lock = false;
					
					Gateway.pontkezdo = Gateway.pont;
					storagesave();
					
				   	//Gateway.pont += 100;
					//Gateway.palya += 1;					

					visszaallitas = 0;
				   
					hatter1 = addtostage ("hatter1", 0, 0, w, h);
					
					tippszoveg = addtext( w/2, h/2-100, szovegek["tipp"], "70px RobotoRegular", "#000", 1500, "center", 1);				
					tippszoveg.alpha = 0;
					
					ablak_nagy = addsprite("ablak_nagy", 0, 0, w, h, true );
					ablakszoveg = addtext( w/2, h/2-100, Gateway.kezdoszovegek[Gateway.currentstep], "70px RobotoRegular", "#000", 1500, "center", 1);				
					
					scope.stage.update();				
					ablakszoveg.y = h/2-ablakszoveg.getBounds().height/2;
					scope.stage.update();
					
					uzenet = addtext( 50, h-100, szovegek["start"], "40px RobotoRegular", "#FFFFFF", 1050, "left", 1);
					uzenet.alpha = 0;
					
					logo = addsprite ("logo", 0, 50);
					logo.addEventListener("mousedown", fomenube);
					
					bar = addsprite ("bar", w-50-577, 50);

					createjs.Ticker.timingMode = createjs.Ticker.TIMEOUT;
					createjs.Ticker.framerate = myrate;
					createjs.Ticker.addEventListener("tick", tick);
				    createjs.Ticker.addEventListener("tick", createjs.Tween);
				   
					scope.onProxyMessage( {command: 'ready', param: ''} );
					
					updatepalyaszam();
					updatepontszam();

					scope.stage.update();
										
				   	createjs.Touch.enable(scope.stage);
					scope.stage.enableMouseOver(10);
					scope.stage.mouseMoveOutside = true;
					
					//scope.stage.addEventListener("stagemousedown", handleComplete2);
					ablak_nagy.addEventListener("mousedown", handleComplete2);
					
			   }


               function handleComplete2(evt) {
				   
					evt.remove();
				   
					kihagy = addsprite ( "kihagy", kihagypos[0], kihagypos[1] );
					kihagy.addEventListener("mousedown", kattintas);
					kihagy.alpha = 1;
				   
				    if (Gateway.isios){
					   Gateway.audio.powerup.play();
				   }else{
						createjs.Sound.play("powerup");
				   }
				   				   
					//scope.stage.removeEventListener("stagemousedown", handleComplete2);
					ablak_nagy.removeEventListener("mousedown", handleComplete2);
				   	ablak_nagy.alpha=0;
					ablakszoveg.alpha=0;
					
					//Gomb rajzolása
					ujra = addsprite ( "ujra", ujrapos[0], ujrapos[1] );
					ujra.addEventListener("mousedown", kattintas);
					ujra.alpha = 1;

					tovabb = addsprite ( "tovabb", tovabbpos[0], tovabbpos[1] );
					tovabb.addEventListener("mousedown", kattintas);
					tovabb.alpha = 0;


					tipp = addsprite ( "tipp", tipppos[0], tipppos[1] );
					tipp.addEventListener("mousedown", kattintas);
					tipp.alpha = 1;

					szovegkijelzes ("start");
					scope.stage.update();
					
					var mysprite;
					addsprite ( "kor", balfelso[0], balfelso[1] );

					var i;
					for (i = 1; i < 12; i++) {
				
						mysprite = addsprite ( i, balfelso[0], balfelso[1] );
						mysprite.szin = -1;
						mysprite.addEventListener("mousedown", szinezes);
						hozzavalok.push(mysprite);
					}

					for (i = 0; i < szinek.length; i++) {
				
						var graphics = new createjs.Graphics().beginFill(szinek[i]).drawRect( 1100+i*100, 500, 60, 60);
						var sprite = new createjs.Shape(graphics);
						sprite.name = i;
						sprite.alpha=0.2;
						scope.stage.addChild(sprite);
						
						szinkockak.push(sprite);
						sprite.addEventListener("mousedown", szinbeallito);
					}
					
					szinbeallito2(0);

					addtext( 1100, 400, "Színbeállító: kiválaszthatod a festőszínt a színmintákra kattintva", "40px RobotoRegular", "#FFFFFF", 700, "left", 1);

					console.log (hozzavalok);
					
			   }
			   
			   function szinbeallito2(param){
				   
				   if (vege) return;
				   
				   szinkockak[szinpointer].alpha=0.2;
				   szinpointer = param;
				   szinkockak[param].alpha=1;
				   
			   }

			   function szinbeallito(evt){

				   if (vege) return;
				   
				   if (evt==0)return;
				   
				   szinbeallito2(evt.target.name);
				   console.log (evt.target.name);
			   }
			   
			   function szinezes(evt){
				   
				   	if (vege) return;
				   
				   console.log (evt.target.name);
				   
					//evt.target.image.filters = [new createjs.ColorFilter('#ffff00')];
					//evt.target.image.cache(0, 0, 30, 30);
				   
				   		//evt.target.filters = [new createjs.ColorMaskFilter("#ff0000")];
						//evt.target.cache(0,0,evt.target.image.width, evt.target.image.height);
						//stage.addChild(bmp);
						//stage.update();
						
						evt.target.filters = [
							new createjs.ColorFilter(0, 0, 0, 1, szinekrgb[szinpointer][0], szinekrgb[szinpointer][1], szinekrgb[szinpointer][2], 1)
						];
						evt.target.cache(0,0,evt.target.image.width,evt.target.image.height);
						evt.target.szin = szinpointer;
						ellenorzes();
				   
			   }
			   
			   function ellenorzes(){
				   
				   	if (vege) return;
								   
				   console.log("Ellenorzes")
				   
				    var i;
					for (i = 0; i < hozzavalok.length; i++) {
						
						var hozzavalo = hozzavalok[i];
						var mysorsz = hozzavalo.name;
						var myszin = hozzavalo.szin;
						
						if ( myszin == -1){
							console.log("Hiba"); return;
						}
						
						//console.log (mysorsz + " " + myszin);
						
						var osszehasonlito = szomszedok[mysorsz];
						
						var j;
						for (j = 0; j < hozzavalok.length; j++) {
							
							var hozzavalo2 = hozzavalok[j]
							if ( osszehasonlito.includes(hozzavalo2.name)){
								if (myszin == hozzavalo2.szin){
									console.log("Hiba"); return;
								}
							}
						
						}
					}
				   
					szovegkijelzes ("kesz");
					tovabb.alpha = 1;
					kihagy.alpha=0;
					vege=1;
				   
			   }
			   
			   
			   function sugotmutat (){
				   
				    scope.stage.setChildIndex( ablak_nagy, scope.stage.getNumChildren()-1);
				    ablak_nagy.alpha=1;
				   
				    scope.stage.setChildIndex( tippszoveg, scope.stage.getNumChildren()-1);
				   
				   
					tippszoveg.y = h/2-tippszoveg.getBounds().height/2;
					scope.stage.update();
					
					tippszoveg.alpha=1;
				    scope.stage.addEventListener("stagemousedown", sugokikapcs);
				   
			   }
			   
			   function sugokikapcs (){
				    scope.stage.removeEventListener("stagemousedown", sugokikapcs);
				   	ablak_nagy.alpha=0;
					tippszoveg.alpha=0;
			   }
			   
			   function addtostage (id, x, y, w, h){
					var shape;
					shape = new createjs.Shape();
					shape.graphics.beginBitmapFill(loaderSvcLepes3.getResult(id)).drawRect(x, y, w, h);
					scope.stage.addChild(shape);
					return shape;
			   }
			   
			   function addsprite (id, x, y){
				   var bitmap;
				   bitmap = new createjs.Bitmap(loaderSvcLepes3.getResult(id));
				   bitmap.x = x;
				   bitmap.y = y;
				   scope.stage.addChild(bitmap);
				   return bitmap;
			   }
			   
			   	function storagesave(){
				   
				   	var storage = window.localStorage;

					storage.setItem("currentstep", Gateway.currentstep );
					storage.setItem("palya", Gateway.palya);
					storage.setItem("pont", Gateway.pont);
					storage.setItem("pontkezdo", Gateway.pontkezdo );
				   
			   }
			   
			   function fomenube(){
				   
				   	$rootScope.loading = true;					
			   		createjs.Ticker.reset();
					scope.stage.removeAllChildren();
					scope.stage.removeAllEventListeners();
					loaderSvcLepes3.getLoader().removeEventListener("complete", handleComplete);
				   
				   scope.onProxyMessage( {command: 'goto', param: "/fomenu"} );
			   }
			   
			   
			   function szovegkijelzes (id){
				 
				    visszaallitas = Gateway.szovegvisszaallas;
					uzenet.text = szovegek[id];
				    uzenet.alpha = 1;
			   }
			   

			   function addtext (xpos, ypos, text, font, mycolor, mywidth, myalign, myalpha ){
				   var myshape;

					var offsetx = 0;
					var offsety = 0;
				
				   if (xpos<0) xpos=w+xpos;
				   if (ypos<0) ypos=h+ypos;
				   
				   myshape = new createjs.Text(text, font, mycolor);
				   myshape.x = xpos + offsetx;
				   myshape.y = ypos + offsety ;
				   myshape.name = text;
				   
				   scope.stage.addChild(myshape);

				   myshape.lineWidth=mywidth;
				   myshape.textAlign=myalign;
				   myshape.alpha=myalpha;
				   
				   return myshape;
			   }
			   
			    function addsprite (id, x, y){
				   var bitmap;
				   bitmap = new createjs.Bitmap(loaderSvcLepes3.getResult(id));
				   bitmap.name = id;
				   bitmap.x = x;
				   bitmap.y = y;
				   scope.stage.addChild(bitmap);
				   return bitmap;
			   }			   
			   
				function updatepalyaszam (){
					if (palyaszam) scope.stage.removeChild(palyaszam);
					palyaszam = addtext( w-50-420, 75+Gateway.fontdiff, Gateway.palya + "." , "35px RobotoBold", "#FFFFFF", 100, "left", true);
				}

				function updatepontszam (){
					if (pontszam) scope.stage.removeChild(pontszam);
					pontszam = addtext( w-50-110, 75+Gateway.fontdiff, Gateway.pont , "35px RobotoBold", "#FFFFFF", 100, "left", true);
				}
				

			   
			   function tick(event) {

					if (!lock){
						if (visszaallitas>0){
							visszaallitas--;
						}else{
							uzenet.alpha = 0;
						}
					}
					
                   scope.stage.update(event);
               }

				function ujrarajzol(){
					
					console.log ("Újrarajzolás");
				
					var i;
					for (i = 0; i < hozzavalok.length; i++) {
				
				
						hozzavalok[i].szin = -1;
						hozzavalok[i].filters = [];
						hozzavalok[i].cache(0,0,hozzavalok[i].image.width,hozzavalok[i].image.height);
				
					}
					
					szinbeallito2(0);
				
					szovegkijelzes ("start");
					tovabb.alpha = 0;
					kihagy.alpha=1;
					vege=0;
				
				}
				
				function reset(){
					
					ujrarajzol();
					
				}
				

			   function kattintas (event){
				   

					var nev = event.target.name;

					if (nev == "ujra"){
						reset();
						return;
					}

					if (nev == "kihagy"){
						//Gateway.pont += 100;
						Gateway.palya += 1;					
						storagesave();
						
						if (Gateway.isios){
							Gateway.audio.drainmagic.play();
						}else{
							createjs.Sound.play("drainmagic");
						}
						closeandjump();
						return;
					}

					if (nev == "tovabb"){
						
						Gateway.pont += 100;
						Gateway.palya += 1;					
						storagesave();
						
						if (Gateway.isios){
							Gateway.audio.drainmagic.play();
						}else{
							createjs.Sound.play("drainmagic");
						}
						closeandjump();
						return;
					}

					if (nev == "tipp"){
						sugotmutat();
						return;
					}
					
					if (lock)return
					
				   if (Gateway.isios){
					   Gateway.audio.swish.play();
				   }else{
					   createjs.Sound.play("swish");
				   }


					
			   }
			   
			   function closeandjump(step){
					
					$rootScope.loading = true;					
			   		createjs.Ticker.reset();
					scope.stage.removeAllChildren();
					scope.stage.removeAllEventListeners();
					loaderSvcLepes3.getLoader().removeEventListener("complete", handleComplete);
					
					var ide;
					
					if (step === undefined){
						ide=Gateway.steps[++Gateway.currentstep];
						if (ide === undefined){
							Gateway.currentstep = 0;
							ide=Gateway.steps[Gateway.currentstep];
						}
					}else{
						Gateway.currentstep = step;
						ide=Gateway.steps[Gateway.currentstep];
					}
					
					scope.onProxyMessage( {command: 'goto', param: ide} );
					
			   }
			   
           }
       }
   }]);